/**
 * @fileoverview POST handler for the "/app_groups/:app_group_id/placements" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { appGroupsAppGroupIdPlacementsCacheKeys } from "./constants";
import type { PostAppGroupsAppGroupIdPlacementsProps, PostAppGroupsAppGroupIdPlacementsResult } from "./types";

export const postAppGroupsAppGroupIdPlacements = reactQueryMutationAdapter(
  appGroupsAppGroupIdPlacementsCacheKeys,
  ({
    placementId,
    name,
    description,
    appGroupId,
    targeting,
  }: PostAppGroupsAppGroupIdPlacementsProps): Promise<PostAppGroupsAppGroupIdPlacementsResult> => {
    const targetingBody = targeting?.cssSelector && {
      css_selector: targeting.cssSelector,
      insertion_position: targeting.insertionPosition,
      url: targeting.url || null,
      url_match_type: targeting.urlMatchType || null,
    };

    return fetch(
      `/app_groups/${appGroupId}/placements`,
      "POST",
      {
        placement_id: placementId,
        name,
        description,
        ...(targetingBody && { targeting: targetingBody }),
      },
      undefined,
      {
        // don't display a modal on fetch errors
        propagateFetchRequestError: false,
      }
    );
  }
);
